/* eslint-disable @typescript-eslint/no-explicit-any */
export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    if ((window as any).Tawk_API) {
      return;
    }

    (window as any).Tawk_API = (window as any).Tawk_API || {};
    (window as any).Tawk_LoadStart = new Date();

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://embed.tawk.to/67e800648279ca190e1b9290/1inh432sb';
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');

    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript) {
      firstScript.parentNode?.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }
  }
});
